export interface IsSimplePhoneNumberOptions {
  required?: boolean;
}

/**
 * Phone number validation for search fields, mirroring the backend rule:
 * digits only, without spaces or any other characters, optionally prefixed with a single '+'
 * denoting that the searched value starts with a country calling code, 7 to 15 digits in total.
 */
export function isSimplePhoneNumber(value?: string, options?: IsSimplePhoneNumberOptions) {
  if (!value) {
    return !options?.required;
  }

  const phoneNumberRegex = /^\+?[0-9]{7,15}$/;
  return phoneNumberRegex.test(value);
}
